export default __webpack_public_path__ + "static/media/facebook_icon.84d892d9.png";